import { controlToastState } from "risa-oasis-ui_v2";
import {
  editCoverMyMedsRequest,
  getCmmInputDataForOrder,
} from "../bigQuery/nycbsPharmaOrders";

export const reportMedicationIssue = async (
  orderId: string,
  reason: string,
  medicationName: string,
  onClose?: () => void,
) => {
  try {
    const orderResponse = await getCmmInputDataForOrder(orderId);
    const cmmInputData = orderResponse?.["details"];

    if (!cmmInputData) {
      throw new Error("Failed to fetch order data");
    }

    // Use the same payload structure as used elsewhere in the codebase
    // Just add the report_reason to the existing CMM input data and the cmm_medication_option field
    const payload = {
      cover_my_meds_input: {
        ...cmmInputData,
        report_reason: reason,
        cmm_medication_option: medicationName,
      },
      send_to_plan: false,
    };

    controlToastState("re-run-in-progress");

    // Close modal immediately after showing the toast
    if (onClose) {
      onClose();
    }

    await editCoverMyMedsRequest(
      payload,
      orderId,
      "Report Medication",
      undefined,
    );

    controlToastState("form-save-success");
  } catch (error) {
    console.error("Error reporting medication:", error);
    controlToastState("re-run-error");
    throw error;
  }
};
